import {
  Module, Mutation, VuexModule,
} from 'vuex-module-decorators';

@Module({
  namespaced: true,
})
export class UserDataStore extends VuexModule {

  private hasOpenSkontoVouchers: boolean = false;

  get getHasOpenSkontoVouchers(): boolean {
    return this.hasOpenSkontoVouchers;
  }

  @Mutation
  private SET_HAS_OPEN_SKONTO_VOUCHERS(hasOpenSkontoVouchers: boolean): void {
    this.hasOpenSkontoVouchers = hasOpenSkontoVouchers;
  }
}
